import React from 'react';

function BFCP_READY() {
  return(
    <div className='bfcp_ready_container center'>
           <h1>Annual Survey of Colleges Will Be Back Soon!</h1>
      <h2>
          We are currently upgrading the Annual Survey of Colleges with improved functionality.
          We apologize for the inconvenience and appreciate your patience.
          Data collection will be available again soon.
      </h2>  
    </div>
  );
}
export default BFCP_READY;
